<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col lg="4" md="6" sm="12">
                                        <kt-form-group>
                                            <kt-form-label for="psp">
                                                {{ $t('label.psp') }}
                                            </kt-form-label>
                                            <kt-form-select size="4" id="psp" name="psp" v-model="query.psp">
                                                <option value=""></option>
                                                <option
                                                        v-bind:key="index"
                                                        v-for="(psp, index) in psp_list"
                                                        v-bind:value="psp.value"
                                                        :selected="psp.value"
                                                >
                                                    {{ psp.name }}
                                                </option>

                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "from_date"
                                                    v-model="query.from_date"
                                                    type="datetime" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="4" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name= "to_date"
                                                    v-model="query.to_date"
                                                    type="datetime"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <kt-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                    </kt-col>
                                </kt-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>
<script>
    import { i18n } from '@/plugins/i18n'

    export default {
    name: "psp_errors_filter",
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            query: {},
            psp_list: [
                {
                    name: i18n.t('psp.novin'),
                    value: 'novin'
                },
                {
                    name: i18n.t('psp.mellat'),
                    value: 'mellat'
                },
                {
                    name: i18n.t('psp.pasargad'),
                    value: 'pasargad'
                },
                {
                    name: i18n.t('psp.parsian'),
                    value: 'parsian'
                },
                {
                    name: i18n.t('psp.saman'),
                    value: 'saman'
                },
                {
                    name: i18n.t('psp.sepehr'),
                    value: 'sepehr'
                },
                {
                    name: i18n.t('psp.asan-pardakht'),
                    value: 'asanpardakht'
                },
                {
                    name: i18n.t('psp.irankish'),
                    value: 'irankish'
                },
            ],
        }
    },
    methods: {
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
    }
}
</script>
<style scoped>
</style>